import { Inject, Injectable } from '@angular/core';
import { ApiService } from 'src/app/core/services/api.service';
import { QueryService } from 'src/app/core/services/query.service';
import { CrudService } from 'src/app/core/services/crud.service';
import { IPageEvent } from 'src/app/core/models/paginator.model';


import { SnackbarService } from 'src/app/core/services/snackbar-psa.service';
import {  NETWORK_LOSS_ENDPOINT, NETWORK_LOSS_QUERY_SERVICE_INSTANCE } from '../filiere.config';


@Injectable({
  providedIn: 'root'
})
export class NetworkLossService extends CrudService<any> {

  constructor(
    @Inject(NETWORK_LOSS_QUERY_SERVICE_INSTANCE) public readonly query: QueryService<any>,
    public readonly apiService:ApiService,
    protected  override readonly snackbar : SnackbarService
    //@Inject(SnackbarService) protected override readonly snackbar: SnackbarService

  ) {
    super(NETWORK_LOSS_ENDPOINT, apiService, snackbar);
  }
  getAll(parameter : IPageEvent,filter:string, searchData?:any){
    const filtro = filter.length>0 ? `&filter=${encodeURIComponent(filter)}` : ``
    const stringSearch = searchData ? `&search=${searchData}` : ``
    const sort = `&sortBy=${encodeURIComponent('createdAt:DESC')}`
    return this.apiService.get(NETWORK_LOSS_ENDPOINT+"?page="+parameter.pageIndex+"&limit="+parameter.pageSize+filtro+sort)
  }


    getAllFiltered(parameter : IPageEvent, searchData?:any, filters?: Record<string, any>){
        const stringSearch = searchData || ''
        let queryParams: string[] = [];
        if(filters){
          Object.keys(filters).forEach(key => {
    
            if (filters[key]) {
              let filterValue = '';
              if(key.includes('_from')){
                filterValue = `${key.split('_from')[0]}||gte||${filters[key]}`;
              }else if(key.includes('_to')){
                filterValue = `${key.split('_to')[0]}||lte||${filters[key]}`;
              }else{
                if(filters[key] instanceof Object){
                  Object.keys(filters[key]).forEach(k => {
                    if (filters[key][k]){
                      filterValue = `${key}.${k}||eq||${filters[key][k]}`
                    }
                  })
                }else{
                  filterValue = `${key}||eq||${filters[key]}`
                }
              }
              queryParams.push(`filter=${encodeURIComponent(filterValue)}`);
            }
          });
        }
        queryParams.push(`page=${parameter.pageIndex}`);
        queryParams.push(`limit=${parameter.pageSize}`);
        if(searchData) queryParams.push(`search=${stringSearch}`);
        const sort = `&sortBy=${encodeURIComponent('createdAt:DESC')}`
        const queryString = queryParams.length > 0 ? `?${queryParams.join('&')}` : '';
        return this.apiService.get(NETWORK_LOSS_ENDPOINT + queryString + sort);
    
      }

      massiveDelete(ids: number[]) : any{ 
          return this.apiService.delete(NETWORK_LOSS_ENDPOINT, 0, false, {ids: ids} );
      }


}
